import React, { createContext, useContext, useState } from 'react';
import { VendingMachineInfo } from '../types/types';

interface IVendingMachineContext {
    vendingMachineInfo: VendingMachineInfo | undefined,
    setVendingMachineInfo: React.Dispatch<React.SetStateAction<VendingMachineInfo | undefined>>;
    stickerId: string | undefined,
    setStickerId: (stickerId: string) => void,
    // EV connector state for this visit: the slave the sticker is bound to (read at load) and the
    // connector already checked and chosen; LoadVendingMachineInfo resets both
    stickerSlaveId: string | null,
    setStickerSlaveId: (slaveId: string | null) => void,
    confirmedSlaveId: string | null,
    setConfirmedSlaveId: (slaveId: string | null) => void,
}

const defaultState = {
  vendingMachineInfo: undefined,
  setVendingMachineInfo: () => undefined,
  stickerId: undefined,
  setStickerId: () => undefined,
  stickerSlaveId: null,
  setStickerSlaveId: () => undefined,
  confirmedSlaveId: null,
  setConfirmedSlaveId: () => undefined,
};

export const VendingMachineContext = createContext<IVendingMachineContext>(defaultState);

export const VendingMachineProvider = ({ children }) => {
  const [vendingMachineInfo, setVendingMachineInfo] = useState<VendingMachineInfo | undefined>(undefined);
  const [stickerId, setStickerId] = useState<string | undefined>(undefined);
  const [stickerSlaveId, setStickerSlaveId] = useState<string | null>(null);
  const [confirmedSlaveId, setConfirmedSlaveId] = useState<string | null>(null);

  return (
    <VendingMachineContext.Provider
      value={{
        vendingMachineInfo,
        setVendingMachineInfo,
        stickerId,
        setStickerId,
        stickerSlaveId,
        setStickerSlaveId,
        confirmedSlaveId,
        setConfirmedSlaveId,
      }}
    >
      {children}
    </VendingMachineContext.Provider>
  );
};

export const useVendingMachine = () => useContext(VendingMachineContext);
